// removed by extract-text-webpack-plugin
module.exports = {"NavigationItems":"NavigationItems__NavigationItems___yd_d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavigationItems.css
// module id = 91
// module chunks = 0